/**
 * 品类树 API(public,无守卫)。GET /api/v1/guide/categories → L1 节点数组,每 L1 持 L2 children。
 * 生成的 CategoryNodeDTO 未含 children(openapi 未捕获递归),此处本地扩展 children。
 */
import { call } from './client';

export interface CategoryNode {
  id: string;
  name: string;
  parentId?: string | null;
  sortOrder?: number;
  icon?: string | null;
  children?: CategoryNode[];
}

export function getCategoryTree(): Promise<CategoryNode[]> {
  return call<CategoryNode[]>({ method: 'GET', url: '/api/v1/guide/categories' });
}
